import React from 'react'
import { ReactComponent as EyeIcon } from 'assets/svg/shared/eye.svg'

export function ShowButton(props) {
    const {
        width = '22px',
        height = 'auto',
        imgWidth = '16px',
        imgHeight = '28px',
        marginLeft = '0',
        marginRight = '0',
        onClick = () => {},
        className = 'show-button',
        title = 'Show lead',
        color = 'white'
    } = props

    return (
        <button
            type="button"
            className={className}
            style={{ width, height, marginLeft, marginRight }}
            onClick={onClick}
            title={title}
        >
            <EyeIcon height={imgHeight} width={imgWidth} fill={color} />
        </button>
    )
}
